import Config from './interfaces/Config'

const config: Config = {
    defaultPath: '/home',
    basename: '/app', // only at build time to set, like ///able-pro/react/default
    layout: 'vertical',
    subLayout: '', // horizontal-2
    collapseMenu: false, // mini-menu
    layoutType: 'menu-light',
    headerBackColor: 'background-grd-blue',
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true,
    boxLayout: false,
    apiUrl: process.env.REACT_APP_API_URL,
    reportOuttimeAgeWarn: 1,
    reportOuttimeAgeAlert: 2,
    ommitedServicesInOuttime: ['STARTPOS', 'TS', 'STARTSRV']
}
export default config
